import React from "react";
import PropTypes from "prop-types";

import { OuterContainer, Container } from "./styles";

const SectionContainer = ({
    bgColor,
    textColor,
    Spacing4XL,
    removePadding,
    removeTopBottomPadding,
    removeLeftRightPadding,
    removeBottomPadding,
    removeTopPadding,
    isHero,
    className,
    children
}) => {
    return (
        <OuterContainer
            className={className}
            bgColor={bgColor}
            textColor={textColor}
        >
            <Container
                Spacing4XL={Spacing4XL}
                removePadding={removePadding}
                removeTopBottomPadding={removeTopBottomPadding}
                removeLeftRightPadding={removeLeftRightPadding}
                removeTopPadding={removeTopPadding}
                removeBottomPadding={removeBottomPadding}
                isHero={isHero}
            >
                {children}
            </Container>
        </OuterContainer>
    );
};

SectionContainer.propTypes = {
    bgColor: PropTypes.string,
    textColor: PropTypes.string,
    Spacing4XL: PropTypes.bool,
    removePadding: PropTypes.bool,
    removeTopBottomPadding: PropTypes.bool,
    removeLeftRightPadding: PropTypes.bool,
    removeBottomPadding: PropTypes.bool,
    removeTopPadding: PropTypes.bool,
    isHero: PropTypes.bool,
    className: PropTypes.string
};

export { SectionContainer };
